import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function SubscriptionsItem({ premiumCommunityPartners }) {
	const [showAll, setShowAll] = useState(false);
	const { t } = useTranslation();
	const visibleItems = showAll
		? premiumCommunityPartners
		: premiumCommunityPartners?.slice(0, 3);

	return (
		<div className="d-flex justify-content-center align-items-center">
			<div>
				{visibleItems.map((partner, index) => (
					<div key={index}>
						<span>{partner.communityPartnerName}</span>
					</div>
				))}
				{!showAll && premiumCommunityPartners.length > 3 && (
					<button
						onClick={() => setShowAll(true)}
						className="text-primary text-decoration-underline font-medium text-sm">
						+{premiumCommunityPartners.length - 3} {t('label.more')}
					</button>
				)}
			</div>
		</div>
	);
}
